<template>
  <router-link to="/">
    <img src="/campus_logo.svg" alt="Campus" class="h-10 mx-auto" />
  </router-link>
</template>
